import { FormFieldTypes } from "../../../../data/formFieldType";

export const MembershipSubscriptionData = {
  name: "Membership Subscription",
  initialState: {
    subscriptionType: null,
    billingCategory: null,
    applicationType: null,
    linkedMember: null,
    linkSubDate:null,
    applicationTerm: null,
    overseasCompany: "no",
    reinstatementfee: "no",
  },
  formFields: [
    {
      id: "subscriptionType",
      lable: "Subscription Type",
      Field_Name: "Subscription Type",
      fieldType: FormFieldTypes.SELECT,
      dataField: "subscriptionType",
      fieldSetting: {
        placeholder: "Select",
        options: [],
        isDisable: true,
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-6 col-md-6 col-sm-12 mb-2 text-start", // Left
      },
    },
    {
      id: "billingCategory",
      lable: "Billing Category",
      Field_Name: "Billing Category",
      fieldType: FormFieldTypes.SELECT,
      dataField: "billingCategory",
      fieldSetting: {
        placeholder: "Select",
        options: [],
        isDisable: true,
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-6 col-md-6 col-sm-12 mb-2 text-start", // Left
      },
    },
    {
      id: "applicationType",
      lable: "Application Type",
      Field_Name: "Application Type",
      fieldType: FormFieldTypes.SELECT,
      dataField: "applicationType",
      fieldSetting: {
        placeholder: "Select",
        options: [],
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-6 col-md-6 col-sm-12 mb-2 text-start", // Left
      },
    },
    {
      id: "linkedMember",
      lable: "Linked Member",
      Field_Name: "Linked Member",
      fieldType: FormFieldTypes.SELECT,
      dataField: "linkedMember",
      fieldSetting: {
        placeholder: "Select",
        options: [],
        isDisable: true,
      },
      style: {
        containerCss: "col-lg-3 col-md-3 col-sm-12 mb-2 text-start", // Left
      },
    },
     {
      id: "linkSubDate",
      lable: "Linked Subscription Period",
      Field_Name: "Linked Member",
      fieldType: FormFieldTypes.INPUT,
      dataField: "linkSubDate",
      fieldSetting: {
        isDisable: true,
      },
      validation: [],
      style: {
        containerCss: "col-lg-3 col-md-3 col-sm-12 mb-2 text-start", // Left
      },
    },
    {
      id: "applicationTerm",
      lable: "Application Term",
      Field_Name: "Application Term",
      fieldType: FormFieldTypes.SELECT,
      dataField: "applicationTerm",
      fieldSetting: {
        placeholder: "Select",
        options: [],
        isDisable:false
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-6 col-md-6 col-sm-12 mb-2 text-start", // Left
      },
    },
    {
      id: "overseasCompany",
      label: "Overseas Company",
      Field_Name: "Overseas Company",
      fieldType: FormFieldTypes.RADIOBUTTON,
      dataField: "overseasCompany",
      fieldSetting: {
        placeholder: "",
        options: [
          { label: "Yes", value: "yes", isDisable: false },
          { label: "No", value: "no", isDisable: false, optionClass: "mr-3" },
        ],
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-6  col-6 mb-4 mt-2 x-position",
      },
    },
    {
      id: "reinstatementfee",
      label: "Reinstatement Fee",
      Field_Name: "Reinstatement Fee",
      fieldType: FormFieldTypes.RADIOBUTTON,
      dataField: "reinstatementfee",
      fieldSetting: {
        placeholder: "",
        options: [
          { label: "Yes", value: "yes", isDisable: true },
          { label: "No", value: "no", isDisable: true, optionClass: "mr-3" },
        ],
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-6  col-6 mb-4 mt-2 x-position",
      },
    },
  ],
  formSetting: {
    isViewOnly: false,
  },
};
